// extracted by mini-css-extract-plugin
module.exports = {"partOne":"LawPage__partOne__3Pd0Y","Background":"LawPage__Background__sNY9m","SignFirtOne":"LawPage__SignFirtOne__ALTiP"};